import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CartCalculationService} from 'src/app/cart/service/cart-calculation.service';
import {FinishProfileItem} from 'src/app/product-details/interface/finish-profile-item-list';
import {PriceCalculationService} from 'src/app/product-details/service/price-calculation.service';
import {ToastMessageService} from 'src/app/services/toast-message.service';
import {CurrencyResolverService} from "../../../../currency-resolver.service";
import {ApCurrency} from "../../../../pipe/enum/ap-currency";

@Component({
	selector: 'fb-select-more-finish',
	templateUrl: './select-more-finish.component.html',
	styleUrls: ['./select-more-finish.component.scss']
})
export class SelectMoreFinishComponent implements OnInit {
	public selectedCurrency: ApCurrency = ApCurrency.INR;

	constructor(
		public _toast: ToastMessageService,
		private _priceCalculation: PriceCalculationService,
		private _currencyResolver: CurrencyResolverService,
		private _cartCalculation: CartCalculationService
	) {

	}
	@Output() closeFInish = new EventEmitter();
	@Output() continiueFinishClicked = new EventEmitter<FinishProfileItem[]>();

	@Input() finishProfileMorethan4Image: FinishProfileItem[] = [];

	public isSelected: boolean = false;
	public moreFabricDataPassToParent: FinishProfileItem[] = []
	public selectedFinish = {} as FinishProfileItem;
	public moreFinishData: FinishProfileItem = {} as FinishProfileItem;
	public deltaIndex : number= -1;
	public closeInfo: boolean = false;

	public closeFinisCLose(): void {
		this.closeFInish.emit()
	}

	public continueFinisCLose(): void {
		// if (!this.isSelected) {
		// 	this._toast.error('Please Select a finish from the list', 'Please Select a finish from the list to proceed.')
		// 	return
		// }

		this.continiueFinishClicked.emit(this.moreFabricDataPassToParent);
		this.closeFInish.emit();
	}

	public moreFinishOption(i: number, obj: FinishProfileItem): void {
		// if(this.deltaIndex)
		this.deltaIndex = i;
		this.selectedFinish = obj;
		this.isSelected = true;

		// debugger
		if (this.finishProfileMorethan4Image[i].checked == true) {
			this.finishProfileMorethan4Image[i].checked = false;
		}
		else {
			this.finishProfileMorethan4Image[i].checked = true;
		}

		let tempPassData: FinishProfileItem[] = []

		this.finishProfileMorethan4Image.forEach((element: FinishProfileItem, i: number) => {

			if (element.checked) {
				tempPassData.push(this.finishProfileMorethan4Image[i]);
				this._cartCalculation.selectedFinishForCartCalc.push(this.finishProfileMorethan4Image[i]);
			}

		});

		// debugger
		this.moreFabricDataPassToParent = [...this.removeDuplicate(tempPassData)];
	}

	public removeDuplicate(arr: FinishProfileItem[]): FinishProfileItem[] {
		const ids = arr.map(o => o.id); // remove duplicate
		const filtered = arr.filter(({ id }, index) => !ids.includes(id, index + 1));
		return filtered;
	}

	public ngOnInit(): void {
		this.selectedCurrency = this._currencyResolver.getSelectedCurrency();
		this._currencyResolver.selectCurrencyChange.subscribe(()=> {
			this.selectedCurrency = this._currencyResolver.getSelectedCurrency();
		});
	}

	public moreFinishDataShow(index: number, finishItem: FinishProfileItem): void {

		this.moreFinishData = finishItem;
		this.closeInfo = true;
	}

	public closeInfoPopup(): void {
		this.closeInfo = false;
		this.moreFinishData = {} as FinishProfileItem;
	}

}
